var $         = require("jquery");
var logError  = require("./error.js");

var ShareJsDocLoader = function(root, dataManager, config, userController) {
    this.root = root;
    this.dataManager = dataManager;
    this.datamodel_version = config.datamodel.datamodel_version;
    this.url = config.url;
    this.userController = (userController || false); // optional usercontroller to logout in case 401 UNAUTHORIZED occures
};
module.exports = ShareJsDocLoader;

ShareJsDocLoader.prototype.openDocument = function(doc_options, nodesToSkip) {
    var self = this;
    this.readOnly = doc_options.readOnly;
    var apiPromise = this.loadAPI();

    var assetPromise = Promise.resolve();
    if (!doc_options.id || doc_options.id.length === 0) {
        if (doc_options.creationAllowed){
            assetPromise = assetPromise.then(function() {
                return self.createNewResource(doc_options);
            });
        } else {
            var err = new Error("Not allowed to create a new asset");
            logError("ShareJsDocLoader", err, logError.criticality.BLOCKING, "Not allowed to create a new asset");
            return Promise.reject(err);
        }
    } else {
        assetPromise = assetPromise.then(function() {
            return self.dataManager.getResource(doc_options.assetType, doc_options.id);
        });
    }

    assetPromise = this.redirectToReadOnlyModeIfNoWriteAccess(assetPromise);

    // TODO: Following part should disappear! Doesn't make sense you should get the colab doc from CS in order to know were to find that colabdoc on the colab server!
    // TODO: what about datamodel changes?
    if (!doc_options.id || doc_options.id.length === 0) {
        assetPromise = assetPromise.then(function(asset) {
            return self.dataManager.getEmptyColabDoc(doc_options.assetType, doc_options.id, self.datamodel_version)   // TODO: should be unnecessary
            .then(function(res) {
                asset.header = res["header"];
                asset.collabDocStoreConfig = res["header"]["collabDocStoreConfig"];
                return asset;
            });
        });
    } else {
        assetPromise = assetPromise.then(function(asset) {
            return self.dataManager.getResourceColabDoc(doc_options.assetType, doc_options.id, self.datamodel_version)
            .then(function(res) {
                asset.header = res["header"];
                asset.collabDocStoreConfig = res["header"]["collabDocStoreConfig"];
                return asset;
            });
        });
    }

    return Promise.all([apiPromise, assetPromise])  //loading api and creating or retrieving asset can be done in parallel
    .then(function(res) {
        var sharedDoc = res[0];
        var asset = res[1];
        self.root.asset = asset;
        return self.openShareJsDoc(sharedDoc, asset)
            .then(function(){
                return self.loadShareJsDoc(sharedDoc, asset,  doc_options.dataClass, nodesToSkip);
            });
    });
};

ShareJsDocLoader.prototype.redirectToReadOnlyModeIfNoWriteAccess = function(assetPromise) {
    var self = this;
    return assetPromise.then((asset) => {
        if(asset.hasUserWritePermissions()
            || self.readOnly) {
            return asset;
        } else {
            var newMode = 2;
            var new_ = "";
            var modeSet = false;
            window.location.search.substr(1).split("&").forEach(function(part) {
                var item = part.split("=");
                if(item.length != 2) return;
                if(item[0] == "mode") {
                    item[1] = newMode;
                    modeSet = true;
                }
                new_ += `&${item[0]}=${item[1]}`;
            });
            if(!modeSet)
                new_ += `&mode=${newMode}`;
            window.location.search = new_;
        }
    });
};

ShareJsDocLoader.prototype.loadAPI = function() {
    var self = this;
    return new Promise(function(resolve, reject) {
        $.ajax({
            url: self.url+"/collaboration/jsapi/v1",
            cache: true,
            dataType: "script"
        })
        .done(function(){
            resolve(window.adsk.collaboration.SharedDoc);
        })
        .fail(function(jqxhr, settings, exception) {
            reject(exception);
        });
    });
};

ShareJsDocLoader.prototype.createNewResource = function(doc_options) {
    var self = this;
    var assetType = doc_options.assetType;
    var capitalizedAssetType = assetType.charAt(0).toUpperCase() + assetType.slice(1);
    var emptyResource = {
        "name": "New "+capitalizedAssetType,
        "description": "",
        "tags": [],
        "score": 0,
        "hub": doc_options.hub
    };
    if(doc_options.assetType == "library"){ emptyResource['assets'] = []; } // TODO: this doesn't belong here!
    return self.dataManager.createResource(emptyResource, doc_options.assetType)
    .then(function(res) {
        doc_options.id = res["id"];
        window.history.pushState(null, "", "?assetid="+res["id"]); //Change url to include assetid
        return self.dataManager.getResource(doc_options.assetType, doc_options.id); // TODO:no need to get just created resource, createResource should return created resource
    });
};


ShareJsDocLoader.prototype.openShareJsDoc = function(sharedDoc, asset) {
    var self = this;
    return new Promise(function(resolve, reject) {
        if(!asset.sharejs_id) throw new Error("No sharejs id");
        sharedDoc.openAndSubscribe(
            asset.collabDocStoreConfig["tenant"],
            asset.sharejs_id,
            {
                'origin': asset.collabDocStoreConfig["urls"]["shareJSServer"],
                'authcallkey': asset.collabDocStoreConfig["authorization-endpoint"],
                'formatversion': self.datamodel_version
                // 'connectTime': Date.now,  // not used!
                // 'name': $(".username_holder").text() // TODO: not used anymore, if important this should get passed via constructor!
            },
            resolve,
            function (error) {
                reject(error);
            }
        );
    });
};

ShareJsDocLoader.prototype.loadShareJsDoc = function(sharedDoc, asset, dataClass, nodesToSkip) {
    var self = this;

    var json = sharedDoc.snapshot();

    if (!json){ // create new asset data: TODO: this header should have been created on the CS already
        var tempRoot = new this.root.constructor();
        tempRoot.attachData(new dataClass(true));   // TODO: this is not clean!
        json = this.root.getEmptyDoc();
        json["body"] = tempRoot.jsonify();
        json["header"] = {
            "assetId": asset.id,
            "assetType": asset.type,
            "colabDocId": asset.sharejs_id,
            "datamodel_version": this.datamodel_version
        };
    }else{
        json["header"] = asset.header;
    }

    sharedDoc.init(json);   // init the sharedDoc => TODO: maybe this should move to the shareableRoot.connectTo function

    console.assert(json["header"]["assetId"] === asset.id, "assetid does not match requested document");

    if(json["body"]["$class"] !== dataClass.$class) {
        var error = new Error("Can't open incompatible document");
        logError("ShareJsDocLoader", error, logError.criticality.CRITICAL, "This type of document can't be opened in this editor.");
        throw error;
    }

    // Check the mode in which the editor is started. If not in EDIT mode, unsubscribe from shareJS doc.
    // TODO TAYLOR FIX THIS
    if (self.readOnly) sharedDoc.unsubscribe();

    return Promise.resolve()
    .then(function() {
        //Is there a reason why we ran preloadReferencedAssets on the entire json instead of just the body?
        return self.root.dataLoader.preloadReferencedAssets(json.body, false, nodesToSkip);
    })
    .then(function() {
        self.root.connectTo(sharedDoc, nodesToSkip);
    });
};

ShareJsDocLoader.prototype.afterLoad = function() {
};
